export const LOAD_ALL_PARAM_SUCCESS = "ACTIVITIES:LOAD_ALL_PARAM_SUCCESS";
export const LOAD_ALL_PARAM_FAILURE = "ACTIVITIES:LOAD_ALL_PARAM_FAILURE";

export const CREATE_ITEM_SUCCESS = "ACTIVITIES:CREATE_ITEM_SUCCESS";
export const CREATE_ITEM_FAILURE = "ACTIVITIES:CREATE_ITEM_FAILURE";

export const EDIT_ITEM_SUCCESS = "ACTIVITIES:EDIT_ITEM_SUCCESS";
export const EDIT_ITEM_FAILURE = "ACTIVITIES:EDIT_ITEM_FAILURE";

export const DELETE_ITEM_SUCCESS = "ACTIVITIES:DELETE_ITEM_SUCCESS";
export const DELETE_ITEM_FAILURE = "ACTIVITIES:DELETE_ITEM_FAILURE";
